<template>
	<div :class="classes" :style="avatarContainerStyle">
		<img
			v-if="hasPicture"
			:alt="user.displayName"
			:src="user.picture"
		/>
		<div
			v-else
			class="white--text user-avatar__initials text-noselect"
			:style="`font-size: calc(${ size } * 0.45); width:100%; text-align:center;`"
		>
			<slot name="initials">{{ avatarInitials }}</slot>
		</div>
	</div>
</template>

<script>
import { userInitialsFilter } from "../utils";

export default {
	name: "UserAvatar",
	props: {
		className: {
			type: String,
			default: "",
		},
		style: {
			type: String,
			default: "",
		},
		/** { displayName:String, picture:String, [ firstName:String, lastName:String, email:String, ] } **/
		user: {
			type: Object,
			default() {
				return {};
			},
		},
		size: {
			type: String,
			default: "1.5rem", // 24px
		},
	},
	computed: {
		classes() {
			return {
				"user-avatar": true,
				[ this.className ]: !!this.className,
			};
		},
		avatarContainerStyle() {
			return `width: ${ this.size }; aspect-ratio: 1/1; ${ this.style }`.trim();
		},
		avatarInitials() {
			return userInitialsFilter( this.user );
		},
		hasPicture() {
			return !!this.user?.picture;
		},
	},
};
</script>

<style lang="scss" scoped>
.user-avatar {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: auto;
	border-radius: 50%;
	margin-left:auto;
	margin-right:auto;
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		position: absolute;
		left: 50%;
		top: 50%;
		height: 100%;
		width: auto;
		-webkit-transform: translate(-50%,-50%);
		-ms-transform: translate(-50%,-50%);
		transform: translate(-50%,-50%);
	}
}

.user-avatar__initials {
	width: 100%;
	height: 100%;
	color: $userAvatar-color;
	background-color: $userAvatar-background-color;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
